import React from 'react';
import { useData } from '../context/DataContext';
import LoadingSpinner from '../components/LoadingSpinner';

const LoadingPage = () => {
  const { loadingProgress, loadingStatus } = useData();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <LoadingSpinner />
        <div className="mt-6 px-2">
          <div className="w-64 bg-gray-200 rounded-full h-2 mx-auto mb-4">
            <div 
              className="bg-primary-600 h-2 rounded-full transition-all duration-300" 
              style={{ width: `${loadingProgress}%` }}
            />
          </div>
          <p className="text-gray-600">{loadingStatus}</p>
          <p className="text-sm text-gray-500 mt-2">{Math.round(loadingProgress)}% complete</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;